import Backbone from 'backbone';
import BaseView from '../../base-view';

/**
 * View for filling in a date and optional a time
 * Consists of input fields and element with the preview of the date/time
 **/
export default BaseView.extend({
	events: {
		'change .js-day': 'onDateChange',
		'change .js-month': 'onDateChange',
		'change .js-year': 'onDateChange',
		'change .js-hour': 'onDateChange',
		'change .js-minute': 'onDateChange'
	},

	previewLength: 'short',
	previewFormat: 'date',

	fields: [],

	initialize: function() {
		this.model = new Backbone.Model({Date: null});

		// element references
		this.dayField = this.query('.js-day');
		this.monthField = this.query('.js-month');
		this.yearField = this.query('.js-year');

		// optional fields
		this.hourField = this.query('.js-hour');
		this.minuteField = this.query('.js-minute');

		// preview options
		this.previewLength = this.el.getAttribute('data-date-length') || this.previewLength;
		this.previewFormat = this.el.getAttribute('data-date-format') || this.previewFormat;

		// initialize fields
		this.initFields();
	},

	/**
	 * initialize date fields
	 **/
	initFields: function() {
		// add leading zero to applicable fields and store in array
		this.fields = [];

		if (this.yearField) {
			this.fields.push(this.yearField);
		}

		if (this.dayField.value.length === 1) {
			this.dayField.value = '0' + this.dayField.value;
			this.fields.push(this.dayField);
		}

		// add leading zero to month
		if (this.monthField.value.length === 1) {
			this.monthField.value = '0' + this.monthField.value;
			this.fields.push(this.monthField);
		}

		// add leading zero to hour
		if (this.hourField && this.hourField.value.length === 1) {
			this.hourField.value = '0' + this.hourField.value;
			this.fields.push(this.hourField);
		}

		// add leading zero to minute
		if (this.minuteField && this.minuteField.value.length === 1) {
			this.minuteField.value = '0' + this.minuteField.value;
			this.fields.push(this.minuteField);
		}

		this.onDateChange();
	},

	setDate: function(date) {
		this.dayField.value = date.getDate();
		this.monthField.value = date.getMonth() + 1;
		this.yearField.value = date.getFullYear();

		if (this.hourField) {
			this.hourField = date.getHours();
		}

		if (this.minuteField) {
			this.minuteField = date.getMinutes();
		}

		this.initFields();
	},

	/**
	 * Date change handler
	 **/
	onDateChange: function() {
		var date = new Date(
			this.yearField.value,
			Math.max(parseInt(this.monthField.value) - 1, 0),
			parseInt(this.dayField.value) || 0
		);

		this.model.set('Date', date);
	},

	/**
	 * disable all inputs
	 **/
	disable: function() {
		this.fields.forEach(function(field) {
			field.setAttribute('disabled', 'disabled');
		});
	},

	/**
	 * enable all inputs
	 **/
	enable: function() {
		this.fields.forEach(function(field) {
			field.removeAttribute('disabled');
		});
	}

});
